import styled from 'styled-components';
import { Card, Tag } from 'antd';

// Stats Card - following InfoCard pattern from CampaignDetailStyle
export const StatsCard = styled(Card)`
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  box-shadow: 0px 0px 8px rgba(50, 50, 50, 0.05);
  height: 100%;

  .ant-card-body {
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 16px;
  }
`;

export const StatsIconWrapper = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: ${({ $bgColor }) => $bgColor || '#EDEBF1'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  .anticon {
    font-size: 20px;
    color: ${({ $iconColor }) => $iconColor || '#3d2969'};
  }
`;

export const StatsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StatsValue = styled.div`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  color: ${({ theme }) => theme.settings.primary};
`;

export const StatsLabel = styled.div`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: ${({ theme }) => theme.settings.tertiary};
`;

// Call Status Tag - following SyncStatusTag pattern
export const CallStatusTag = styled(Tag)`
  border-radius: 6px;
  padding: 4px 10px !important;
  margin: 0 !important;
  height: auto !important;
  display: inline-flex;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  gap: 4px;
  border: none;

  &.completed {
    background: rgba(72, 181, 105, 0.1);
    color: #48B569;
  }

  &.pending {
    background: rgba(229, 170, 17, 0.1);
    color: #E5AA11;
  }

  &.processing {
    background: rgba(66, 171, 222, 0.1);
    color: #42abde;
  }

  &.failed {
    background: rgba(220, 38, 38, 0.1);
    color: #DC2626;
  }

  &.no_transcript {
    background: rgba(131, 137, 159, 0.1);
    color: #83899F;
  }
`;

// Transcript Status Tag
export const TranscriptStatusTag = styled(Tag)`
  border-radius: 6px;
  padding: 4px 10px !important;
  margin: 0 !important;
  height: auto !important;
  display: inline-flex;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  gap: 4px;
  border: none;

  &.completed {
    background: rgba(72, 181, 105, 0.1);
    color: #48B569;
  }

  &.pending {
    background: rgba(229, 170, 17, 0.1);
    color: #E5AA11;
  }

  &.processing {
    background: rgba(66, 171, 222, 0.1);
    color: #42abde;
  }

  &.failed {
    background: rgba(220, 38, 38, 0.1);
    color: #DC2626;
  }

  &.not_available {
    background: rgba(131, 137, 159, 0.1);
    color: #83899F;
  }
`;

// Table Action Wrapper - following TableActionWrapper pattern
export const TableActionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

// Transcript Modal Styles
export const TranscriptModalContent = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  padding: 16px 12px 16px 0;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 2px;
    margin: 8px 0;
  }

  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #bfbfbf;
  }
`;

export const TranscriptMessage = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  padding: 12px 16px;
  border-radius: 12px;
  background: ${({ $isAgent }) => $isAgent ? 'rgba(61, 41, 105, 0.05)' : 'rgba(66, 171, 222, 0.1)'};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const TranscriptSender = styled.div`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: ${({ $isAgent }) => $isAgent ? '#3d2969' : '#42abde'};
  margin-bottom: 4px;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const TranscriptText = styled.div`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: ${({ theme }) => theme.settings.primary};
`;

export const TranscriptTimestamp = styled.div`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.settings.tertiary};
  margin-top: 4px;
  text-align: right;
`;

// Call Info Header in Modal
export const CallInfoHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 16px 24px;
  background: rgba(243, 244, 246, 0.5);
  border-radius: 12px;
  margin-bottom: 16px;
`;

export const CallInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 120px;
`;

export const CallInfoLabel = styled.div`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: ${({ theme }) => theme.settings.tertiary};
`;

export const CallInfoValue = styled.div`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: ${({ theme }) => theme.settings.primary};
`;

// Empty State
export const EmptyTranscriptState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;

  .anticon {
    font-size: 48px;
    color: #83899F;
    margin-bottom: 16px;
  }

  h4 {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: ${({ theme }) => theme.settings.primary};
    margin: 0 0 8px 0;
  }

  p {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${({ theme }) => theme.settings.tertiary};
    margin: 0;
  }
`;

// Duration Display
export const DurationDisplay = styled.span`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.settings.tertiary};
`;

// Participant ID Display
export const ParticipantIdCell = styled.div`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.settings.primary};
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// Quality Indicator
export const QualityIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Header Actions Wrapper - to align buttons with tabs
export const HeaderActionsWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  /* Override tab sizing for compact header */
  .view-toggle .toggle-btn {
    padding: 5px 14px !important;
    font-size: 10px !important;
    line-height: 12px !important;
  }

  .action-btn {
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    padding: 5px 14px !important;
    font-size: 10px !important;
    line-height: 12px !important;
    font-weight: 600 !important;
    height: auto !important;
    border-radius: 10px !important;
    display: inline-flex;
    align-items: center;
    gap: 6px;

    .anticon {
      font-size: 12px;
    }
  }

  .refresh-btn {
    width: 28px !important;
    height: 28px !important;
    min-width: 28px !important;
    padding: 0 !important;
    border-radius: 8px !important;
    display: flex;
    align-items: center;
    justify-content: center;

    .anticon {
      font-size: 12px;
    }
  }
`;

// Audio Player Styles - Compact Modern Design
export const AudioPlayerWrapper = styled.div`
  margin-top: 16px;
  background: #fff;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 12px;
  overflow: hidden;
`;

export const AudioPlayerMain = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  background: linear-gradient(180deg, #fafafa 0%, #fff 100%);
`;

export const PlayButtonLarge = styled.button`
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: 50%;
  border: none;
  background: #3d2969;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;

  .anticon {
    font-size: 20px;
    margin-left: 2px; /* Optical centering for play icon */
  }

  &:hover {
    background: #4a3578;
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const AudioProgressSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
`;

export const AudioProgressBar = styled.div`
  width: 100%;
  position: relative;
  padding: 4px 0;

  .ant-slider {
    margin: 0;
    height: 14px;
  }

  .ant-slider-rail {
    height: 6px;
    background: #f0f0f0;
    border-radius: 100px;
    top: 4px;
  }

  .ant-slider-track {
    height: 6px;
    background: linear-gradient(90deg, #a8a0b8 0%, #3d2969 100%);
    border-radius: 100px;
    top: 4px;
  }

  .ant-slider-handle {
    width: 14px !important;
    height: 14px !important;
    border: 2px solid #3d2969 !important;
    background: #3d2969 !important;
    border-radius: 50% !important;
    box-shadow: none !important;
    margin-top: 0 !important;
    top: 0 !important;
    transform: translateX(-50%) !important;

    &::before,
    &::after {
      display: none !important;
    }

    &:hover,
    &:focus,
    &:active {
      background: #3d2969 !important;
      border-color: #3d2969 !important;
      box-shadow: 0 0 0 5px rgba(61, 41, 105, 0.12) !important;
    }
  }

  .ant-tooltip {
    .ant-tooltip-inner {
      background: #1f2430;
      font-size: 12px;
      font-weight: 500;
      min-height: 24px;
      padding: 4px 8px;
      border-radius: 4px;
    }
    .ant-tooltip-arrow::before {
      background: #1f2430;
    }
  }
`;

export const AudioTimeline = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 11px;
  font-weight: 500;
  color: #83899F;
`;

export const AudioControlsBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background: #f8f9fa;
  border-top: 1px solid ${({ theme }) => theme.settings.borderColor};
`;

export const SkipControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SkipButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #3d2969;
  cursor: pointer;
  transition: all 0.15s;

  .anticon {
    font-size: 20px;
  }

  &:hover {
    background: rgba(61, 41, 105, 0.08);
    color: #4a3578;
  }

  &:active {
    transform: scale(0.92);
  }
`;

export const SpeedSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 3px;

  button {
    padding: 6px 10px;
    font-size: 12px;
    font-family: ${({ theme }) => theme.fonts.inter};
    font-weight: 500;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: #83899F;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 42px;

    &:hover {
      color: ${({ theme }) => theme.settings.primary};
      background: rgba(255, 255, 255, 0.5);
    }

    &.active {
      background: #fff;
      color: #3d2969;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
  }
`;

export const AudioActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

// Three-state Quality Toggle (Bad | Neutral | Good)
export const QualityToggleWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  background: ${({ $quality }) =>
    $quality === 'good' ? '#48B569' :
    $quality === 'bad' ? '#ff4d4f' :
    '#bfbfbf'};
  border-radius: 100px;
  padding: 2px;
  width: 70px;
  height: 24px;
  position: relative;
  cursor: pointer;
  transition: background 0.3s;

  &.loading {
    opacity: 0.6;
    pointer-events: none;
  }
`;

export const QualityToggleHandle = styled.div`
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: ${({ $quality }) =>
    $quality === 'bad' ? '2px' :
    $quality === 'neutral' ? 'calc(50% - 10px)' :
    'calc(100% - 22px)'};
  transition: left 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

export const QualityToggleLabels = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 6px;
  font-size: 10px;
  font-weight: 500;
  color: #fff;
  pointer-events: none;

  span {
    opacity: ${({ $quality, $side }) =>
      ($quality === 'bad' && $side === 'left') ||
      ($quality === 'good' && $side === 'right') ? 1 : 0.7};
  }
`;
